import angular from 'angular';
import template from './modalWrapper.html';

export class ModalWrapperController {
  constructor(appResizableScreen) {
    'ngInject';

    this.appResizableScreen = appResizableScreen;
  }
  $onInit() {
    if (angular.isUndefined(this.contentPadding)) {
      this.contentPadding = true;
    }
  }
  $postLink() {
    this.appResizableScreen.update();
  }
  close() {
    this.onClose();
  }
  dismiss($event) {
    if (
      !this.disableOverlayDismissal &&
      $event.target &&
      $event.target.dataset && angular.isDefined($event.target.dataset.modalDismissibleArea)
    ) {
      $event.preventDefault();
      $event.stopPropagation();
      if (this.onDismiss) {
        this.onDismiss();
      } else {
        this.onClose();
      }
    }
  }
}

export default {
  controller: ModalWrapperController,
  template,
  bindings: {
    modalTitle: '<',
    htmlTitle: '<?',
    onDismiss: '&?',
    onClose: '&',
    fullHeight: '<',
    disableOverlayDismissal: '<',
    disableClose: '<',
    contentPadding: '<?',
  },
  transclude: true,
};
